import { makeStyles, createStyles } from '@material-ui/core/styles';
import { theme, variables } from '@styles';

/**
 * TemplateList component styles
 * @returns {Function}
 */
export const useStyles = makeStyles(() =>
  createStyles({
    templateList: {
      backgroundColor: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      display: 'flex',
      flexDirection: 'column',
      height: '85vh',
      padding: theme.spacing(3),
      overflowY: 'hidden',
    },
    header: {
      alignItems: 'center',
      display: 'flex',
      flex: '0 0 auto',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2),
    },
    templates: {
      flex: '1 1 auto',
      height: '100%',
      overflowY: 'auto',
      paddingRight: '1.4rem',
    },
    row: {
      display: 'flex',
      alignItems: 'center',
    },
    title: {
      color: variables.colorV2.text.header,
      fontSize: '2rem',
      fontWeight: 400,
      lineHeight: '2.5rem',
      marginRight: theme.spacing(1),
    },
    emptyContainer: {
      display: 'flex',
      flex: '1 1',
      justifyContent: 'center',
      alignItems: 'center',
      height: '70vh',
    },
    emptyPlaceholder: {
      width: '55%',
      textAlign: 'center',
    },
    selectTemplate: {
      display: 'flex',
      flex: '1 1',
      justifyContent: 'center',
      alignItems: 'center',
      // height: '20rem',
    },
    uploadButton: {
      // border: `1px solid ${variables.color.primary.lightGrayDarker}`,
      minWidth: '3.2rem',
      padding: '0.6rem 0.6rem',
      width: '3.2rem',

      '&:hover': {
        // border: `1px solid ${variables.color.primary.mainPurple}`,
        backgroundColor: 'transparent',
      },
      '&:hover svg path': {
        fill: variables.colorV2.button.contained.primary.icon.fill.hover,
      },
    },
  }),
);
